/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type DateOfBirthRequestPayloadSideEffectType =
  (typeof DateOfBirthRequestPayloadSideEffectType)[keyof typeof DateOfBirthRequestPayloadSideEffectType];

export const DateOfBirthRequestPayloadSideEffectType = {
  date_of_birth_request: "date_of_birth_request",
} as const;
